<template>
  <span>
    <Dialog
      class="test-box"
      :header="headerDialog"
      :visible.sync="showRemoverTomador"
      :modal="true"
      :closable="false"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p>
              {{
                "O " +
                  (this.tipoEmissao == "T" ? "prestador" : "tomador") +
                  " " +
                  (this.pessoa ? this.pessoa.detail : "") +
                  " será removido."
              }}
            </p>
            <p>
              {{ "Deseja continuar?" }}
            </p>
          </div>
        </div>
      </div>

      <hr />

      <div class="botoes-avancar-voltar">
            <Button
              @click="removerTomador()"
              href="#topo"
              type="button"
              label="Remover"
              class="p-button-primary mr-2 p-button-success"
              icon="pi pi-check"
              :disabled="loading"
            />

            <Button
              @click="showRemoverTomador = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
      </div>
    </Dialog>
  </span>
</template>

<script>
import NfsPessoaService from "@/services/nfse/pessoa.service";

export default {
  name: "RemoverTomador",

  props: {
    tipoEmissao: String
  },

  created() {
    this.$root.$on("notaFiscal:removerTomador", () => {
      this.pessoa = this.$parent.selectedPessoa;

      this.exibirDialogRemoverTomador();
    });
  },

  data() {
    return {
      showRemoverTomador: false,
      pessoa: null
    };
  },

  methods: {
    exibirDialogRemoverTomador() {
      this.showRemoverTomador = true;
    },

    removerTomador() {
      if (this.pessoa && this.pessoa.id) {
        this.$parent.processando(true);
        this.$parent.erros = [];

        NfsPessoaService.remove(this.pessoa.id)
          .then(
            data => {
              console.log(data);
              this.$root.$emit(
                "alert:success",
                "O " +
                  (this.tipoEmissao == "T" ? "Prestador" : "Tomador") +
                  " foi removido!"
              );
            },
            error => {
              console.log(error);
              this.$root.$emit(
                "alert:success",
                "Houve um problema ao remover o " +
                  (this.tipoEmissao == "T" ? "Prestador" : "Tomador") +
                  "!"
              );
            }
          )
          .then(() => {
            if (this.$parent.$options.name == "EmissaoNfse") {
              this.$parent.notaFiscal.idTomadorDados = null;
            } else {
              this.$parent.daps.idTomadorDados = null;
              this.$parent.daps.idPrestadorDados = null;
            }

            this.$parent.selectedPessoa = null;
            this.showRemoverTomador = false;
            this.$parent.processando(false);
          });
      }
    }
  },

  computed: {
    headerDialog() {
      return "Remover " + (this.tipoEmissao == "T" ? "Prestador" : "Tomador");
    },

    loading() {
      return this.$parent.loading;
    }
  }
};
</script>

<style scoped></style>
